module.exports = '<!DOCTYPE html>\n<div class="np-licences">\n  <a ng-repeat="l in licences" class="{{l.class}}" ng-href="{{l.href}}">{{l.text}}</a>\n</div>\n';